<template>
    <div class="content-string-selector">
        <label class="is-size-7">Ref ID <input v-model="contentId" class="input is-small" type="text"/></label>
        <span class="tag add-btn" title="add content reference" @click="add()">add</span>
    </div>
</template>

<script>
import contentService from '../../../../services/content.service'

export default {
    name: 'content-string-selector',
    props: {
        clientId: true,
        addFunc: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            contentId: null
        }
    },
    methods: {
        async add() {
            let content = null;

            // find content among client content
            if (this.clientId) {
                let clientContent = await contentService.listStrings(this.clientId);
                content = clientContent.find(c => c.id == this.contentId);
            }

            // find content among common system content
            if (!content) {
                let commonContent = await contentService.listStrings(null);
                content = commonContent.find(c => c.id == this.contentId);
            }

            if (content) {
                this.addFunc({
                    contentId: content.id,
                    clientId: content.clientId,
                    name: content.name,
                    language: content.language
                });
                this.contentId = null;
            } else {
                alert(`Content with ID '${this.contentId}' not fount`)
            }
        }
    }
};
</script>

<style lang="scss">
.content-string-selector {
    padding: 0.28rem;

    input {
        max-width: 180px;
        margin-left: .2rem;
    }

    .add-btn {
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// front/src/components/common/content/string/content-string-selector.vue